import { Navigation } from '@app/navigation/enums/navigation.enum';

export const realEstateAgentAbsoluteRoute = `/${Navigation.RealEstateAgent}`;
export const addLeaverRoute = 'ots/leaver-details/contact-details';
